import HomePageScreen from './Component/home';
import './App.css';

function App() {
  return (
    <div className="App">
      <HomePageScreen />
    </div>
  );
}

export default App;
